export default {
  form: {
    fullName: 'Firstname Name',
    jobTitle: 'Job title',
    mobile: 'Mobile',
    phone: 'Phone',
    email: 'Email',
    fax: 'Fax',
    company: 'Hotel name',
    address: 'Address',
    city: 'Zip code, City',
    country: 'Country',
    facebookLink: 'Facebook Link',
    twitterLink: 'Twitter Link',
    youtubeLink: 'YouTube Link',
    instagramLink: 'Instagram Link',
    operatingCompanyName: 'Operating company name',
    operatingCompanyHeadquarter: 'Company Headquarter',
    operatingCompanyRegistryCourt: 'Court of registration',
    operatingCompanyDirectors: 'Managing director(s)',
    operatingCompanyVat: 'VAT ID number'
  },
  addNewField: 'Add new field',
  editField: 'Edit field',
  uploadImageDescription: 'You can upload image or add the public link to image.'
};
